import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ioteqMediaWatcherModule } from '@tools/services/media-watcher/media-watcher.module';
import { ioteqSplashScreenModule } from '@tools/services/splash-screen/splash-screen.module';
import { ioteqTailwindConfigModule } from '@tools/services/tailwind/tailwind.module';
import { ioteqUtilsModule } from '@tools/services/utils/utils.module';

@NgModule({
    imports  : [
        ioteqMediaWatcherModule,
        ioteqSplashScreenModule,
        ioteqTailwindConfigModule,
        ioteqUtilsModule
    ],
    providers: [
        {
            // Use the 'fill' appearance on Angular Material form fields by default
            provide : MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'fill'
            }
        }
    ]
})
export class ioteqModule
{
    /**
     * Constructor
     */
    constructor(@Optional() @SkipSelf() parentModule?: ioteqModule)
    {
        if ( parentModule )
        {
            throw new Error('ioteqModule has already been loaded. Import this module in the AppModule only!');
        }
    }
}
